<button class="rounded-button text-uppercase d-flex align-items-center justify-content-center {{btnClass}}"
        [disabled]="isDisabled"
        (click)="onClickButton($event)">
  <ng-content></ng-content>
  <span class="fw-medium">{{ label }}</span>
</button>
